<template>
    <div class="app">
        <app-header :fixed="fixedHeader || fixedSidebar" />
        <div class="app-body">
            <sidebar
            :nav-items="nav"
            :fixed="fixedSidebar"
            />
            <main class="main">
                <breadcrumb :list="list" />
                <div class="container-fluid">
                    <router-view />
                </div>
            </main>
            <template v-if="tracksLoadStatus == 2
            && this.$route.name != 'AlbumDetails'
            && this.$route.name != 'TrackDetails'">
                <c-persistent-player style="z-index: 9999"></c-persistent-player>
            </template>
        </div>
        <app-footer />
    </div>
</template>

<script>
import nav from './_nav'
import cPersistentPlayer from './components/Player/PersistentPlayer.vue'
import { Header as AppHeader, Sidebar, Footer as AppFooter, Breadcrumb } from './components'

export default {
    name      : 'UserContainer',
    components: {
        AppHeader,
        Sidebar,
        AppFooter,
        Breadcrumb,
        cPersistentPlayer
    },
    data () {
        return {
            nav         : nav.items,
            offset      : true,
            fixedHeader : true,
            fixedSidebar: true,
        }
    },
    computed: {
        name () {
            return this.$route.name
        },
        list () {
            return this.$route.matched
        },
        tracks(){
            return this.$store.state.player.tracks;
        },
        tracksLoadStatus(){
            return this.$store.state.player.tracksLoadStatus;
        }
    },
    mounted () {
        // Resize sidebar if needed
        // this.resizeSidebar(this.$route.name)

        if (this.$store.get('user/userLoadStatus') == 0) {
            this.$store.dispatch('user/getUser')
        }

        $('body').addClass('app sidebar-lg-show pace-done')
        $(window).on('scroll', this.setPosNotify)

        // Minimize sidebar by default
        document.body.classList.toggle('sidebar-minimized')
        document.body.classList.toggle('brand-minimized')
    },
    beforeDestroy () {
        $('body').removeClass('app sidebar-lg-show pace-done')
        $(window).off('scroll', this.setPosNotify)
    },
    methods: {
        setPosNotify () {
            const top    = $(document).scrollTop()
            const height = $('.app-header').height()
            const offset = top < height ? height - top : 0

            this.offset = `${offset}px`
        },
        // resizeSidebar(routeName) {
        //     if (routeName == "AlbumDetails") {
        //         $('.sidebar-fixed .sidebar').css('height', 'calc(100vh - 55px - 100px)')
        //     } else {
        //         $('.sidebar-fixed .sidebar').css('height', 'calc(100vh - 55px)')
        //     }
        // }
    },
    // watch:{
    //     $route (to, from){
    //         this.resizeSidebar(to.name)
    //     }
    // }
}
</script>
